export const TAB_IDS = {
  EMAIL_TEMPLATES: "email-templates",
  DOCUMENT_TEMPLATES: "document-templates",
  APPROVAL_WORKFLOWS: "approval-workflows",
  INVOICE_SETTINGS: "invoice-settings",
  WEBHOOKS: "webhooks",
  CACHE_MANAGEMENT: "cache-management"
};
